import { render, staticRenderFns } from "./CustomSpanDasboard.vue?vue&type=template&id=5b2a99dc"
import script from "./CustomSpanDasboard.vue?vue&type=script&lang=js"
export * from "./CustomSpanDasboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports